import React from 'react';
import { makeStyles } from '@mui/styles';
import { Button, DialogContent, DialogActions, TextField, Grid } from '@mui/material';
import { useDropzone } from 'react-dropzone';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Formik } from 'formik';
import { useParams } from 'react-router';
import { addUpdateFile } from '../../api';
import CircularProgress from '@mui/material/CircularProgress';

const useStyles = makeStyles((theme) => ({
    customToastProgress: {
        backgroundColor: '#F59300',
    },
}));

export default function FileUploadBox({ handleClosePopup, selectedRow, fetchFileList }) {
    const classes = useStyles();
    const { id } = useParams();
    const [selectedFile, setSelectedFile] = React.useState(null);
    const [fileLabel, setFileLabel] = React.useState("");
    const [fileBase64, setFileBase64] = React.useState('');
    var [loading, setLoading] = React.useState(false);
    const showFileSelectError = () => toast("Please select a file first", { progressClassName: classes.customToastProgress });
    const addFile = () => toast("Folder Name Added Successfully!", { progressClassName: classes.customToastProgress });
    const updateFile = () => toast("Folder Name Added Successfully!", { progressClassName: classes.customToastProgress });
    const errorMessage = () => toast("An error occured, try again later!", { progressClassName: classes.customToastProgress });

    const { getRootProps, getInputProps, isDragActive } = useDropzone({
        onDrop: (acceptedFiles) => {
            const file = acceptedFiles[0];
            setSelectedFile(file);
            const reader = new FileReader();
            reader.onload = (e) => {
                setFileBase64(e.target.result.split(',')[1]);
            };
            reader.readAsDataURL(file);
        },
        multiple: false,
    });

    return (
        <DialogContent>
            <ToastContainer theme="dark" />
            <Formik enableReinitialize initialValues={{ FileLabel: selectedRow?.fileLabel || "" }}
                validate={(values) => {
                    const errors = {};
                    if (!selectedFile) {
                        showFileSelectError();
                    }
                    if (!values.FileLabel) {
                        errors.FileLabel = "Required!";
                    }
                    return errors;
                }}
                onSubmit={async (values, { setSubmitting }) => {
                    setLoading(true);
                    const postData = {
                        id: selectedRow?.id || 0,
                        folderId: id,
                        FileName: selectedFile?.name,
                        FileLabel: values.FileLabel,
                        fileData: fileBase64
                    };
                    console.log(postData);

                    try {
                        const res = await addUpdateFile(postData);
                        if (res.data.successCode === 0) {
                            { selectedRow?.id ? updateFile() : addFile() }
                            fetchFileList(id);
                        } else {
                            errorMessage();
                        }
                        console.log("File upload successful!");
                    } catch (err) {
                        setTimeout(() => errorMessage(), 1000);
                    } finally {
                        setLoading(false);
                        setSubmitting(false);
                        handleClosePopup();
                    }
                }}
            >
                {({
                    values,
                    errors,
                    touched,
                    handleChange,
                    handleBlur,
                    handleSubmit,
                    isSubmitting,
                }) => (
                    <form onSubmit={handleSubmit}>
                        <div
                            {...getRootProps()}
                            style={{
                                border: "2px dashed #F59300",
                                borderRadius: "10px",
                                padding: "30px",
                                textAlign: "center",
                                cursor: "pointer",
                                backgroundColor: isDragActive
                                    ? "rgba(245,147,0,0.1)"
                                    : "#fff",
                            }}
                        >
                            <input {...getInputProps()} />
                            {isDragActive ? (
                                <p>Drop the file here...</p>
                            ) : (
                                <p>Drag & drop a file here, or click to select</p>
                            )}
                        </div>

                        {selectedFile && (
                            <div
                                style={{
                                    marginTop: "20px",
                                    padding: "10px 15px",
                                    display: "flex",
                                    alignItems: "center",
                                    border: "1px solid #ddd",
                                    borderRadius: "8px",
                                    backgroundColor: "#fafafa",
                                    boxShadow: "0px 2px 4px rgba(0,0,0,0.1)",
                                }}
                            >
                                <InsertDriveFileIcon
                                    style={{
                                        fontSize: 35,
                                        color: "#888",
                                        marginRight: "10px",
                                    }}
                                />
                                <div>
                                    <div
                                        style={{
                                            fontSize: "14px",
                                            fontWeight: "bold",
                                            color: "#333",
                                        }}
                                    >
                                        {selectedFile.name}
                                    </div>
                                    <div style={{ fontSize: "12px", color: "#666" }}>
                                        {(selectedFile.size / 1024).toFixed(2)} KB
                                    </div>
                                </div>
                            </div>
                        )}

                        {selectedFile && (
                            <Grid item xs={12} sm={6} md={6}>
                                <TextField fullWidth label="File Label" variant="outlined" name="FileLabel" value={values.FileLabel || ""} onChange={handleChange} onBlur={handleBlur} style={{ marginTop: "20px" }} size="small" />
                                <div className="errMsg" style={{ marginTop: "5px" }}>{errors.FileLabel && touched.FileLabel && errors.FileLabel}</div>
                            </Grid>
                        )}

                        <DialogActions style={{ marginTop: "20px" }}>
                            <Button
                                type="button"
                                variant="outlined"
                                color="primary"
                                className="noShadow cancelBtn"
                                onClick={handleClosePopup}
                            >
                                Cancel
                            </Button>
                            <Button
                                type="submit"
                                variant="contained"
                                color="primary"
                                className="noShadow addBtn"
                                style={{ width: "85px" }}
                                disabled={isSubmitting}
                            >
                                {loading ? <CircularProgress size="25px" color="inherit" /> : "Upload"}
                            </Button>
                        </DialogActions>
                    </form>
                )}
            </Formik>
        </DialogContent>
    );
}